import React from 'react';
import { useCartItemCount } from '../../contexts';
import './CartIcon.css';

interface CartIconProps {
  onClick?: () => void;
  className?: string;
  showBadge?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const CartIcon: React.FC<CartIconProps> = ({
  onClick,
  className = '',
  showBadge = true,
  size = 'medium'
}) => {
  const itemCount = useCartItemCount();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`cart-icon cart-icon--${size} ${className}`}
      onClick={handleClick}
      aria-label={`Shopping cart with ${itemCount} items`}
      type="button"
    >
      <svg
        className="cart-icon__svg"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V17C17 18.1 16.1 19 15 19H9C7.9 19 7 18.1 7 17V13M17 13H7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      
      {showBadge && itemCount > 0 && (
        <span className="cart-icon__badge" aria-label={`${itemCount} items in cart`}>
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </button>
  );
};

export default CartIcon;
